<template>
    <div class="search-filter">
        <div class="container top">
            <multiselect v-model="filter_by" :options="searchItems" group-label='name' group-values='types' label='name' name='name' track-by='pk' :groupSelect="true" :multiple="true" :close-on-select="false" :taggable="true" :hideSelected="true" @tag='addTag'  tagPlaceholder='Press enter to add to search'>
                <template slot="option" slot-scope="props">
                    <div v-if="props.option.$isLabel" :id="'option-'+props.option.$groupLabel.replace(' ', '-')" class='groupLabel' v-on:click.stop v-on:mousedown.stop="groupTag(props.option.$groupLabel)">{{ props.option.$groupLabel }}</div>
                    <div v-else-if="props.option.name" :id="'option-'+props.option.name.replace(' ', '-')">{{ props.option.name }}</div>
                    <div v-else-if="props.search">{{ props.search }}</div>
                </template>
            </multiselect>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import Multiselect from 'vue-multiselect'
export default{
    name: 'searchblock',
    data() {
        return {
            filter_by: [],
            itemsPerRow: 12,
            // filter_arrays: this.setFilterArray(),
            // filter_arrays: this.searchItems.map(item => {
            //     return { 'anded': item.value.and_search, 'options': [] }
            // }),
            // openTracker: this.searchItems.map(item => false),
            searchItems: [],
        }
    },
    props: {
        // searchItems: {
        //     type: Array,
        //     required: true,
        // },
        pageType: {
            type: String,
            required: false,
        },
        curIndex:{
            type: Number,
            default: -1
        }
    },
    components: {
        Multiselect
    },
    watch:{
        filter_by() {
            this.$emit('filterChange', this.filter_by)
        },
        // $route (to, from){
        //     this.openTracker = this.searchItems.map(item => false)
        // },
    },
    computed: {
        numRows() {
            return Math.ceil
        },
    },
    mounted (){
        
    },
    created (){
        window.addEventListener('click', this.documentClick)
        this.fetchSearchData().then(data => {
            this.searchItems = data;
        })
    },
    destroyed (){
        window.removeEventListener('click', this.documentClick)
    },
    methods: {
        fetchSearchData(){
            var id = this.$route.meta.id
            return axios.get('/api/get_categories').then(response => {
                //  console.log(JSON.stringify(response))
                return response.data;
            })
        },
        addTag(newTag) {
            const tag = {
                name: newTag,
                pk: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
            }
            // this.searchItems.push(tag)
            this.filter_by.push(tag)
        },
        groupTag(value) {
            console.log('Fire!');
            let exists = false;
            let exists_at = null;
            for (let i in this.filter_by) {
                if (this.filter_by[i].name == value) {
                    exists = true;
                    exists_at = i;
                    break;
                }
            }
            if (exists) {
                this.filter_by.splice(exists_at, 1);
            } else {
                let tag = {
                    name: value,
                    pk: value.substring(0, 2) + Math.floor(Math.random() * 10000000)
                }
                this.filter_by.push(tag);
            }
            
        },
        documentClick(e){
            var checkboxes = document.getElementsByClassName('dropdown-options')
            var buttons = document.getElementsByClassName('dropdown-button')
            var el_array = Array.prototype.slice.call(buttons)
            var show_it = el_array.indexOf(e.target)
            var contains = false

            // if (buttons.indexOf(e.target))
          
            if(e.target.classList.contains('dropdown-button') && this.openTracker.indexOf(true) !== -1 ){
                // this.openTracker = this.searchItems.map(item => false)
                console.log('OPEN TRACKER')
            }

            for(var index = 0; index < checkboxes.length; index++){
                if(checkboxes[index].contains(e.target)){
                   contains = true
                }
            }

            // if (show_it === -1 && contains !== true) {
            //    this.openTracker = this.searchItems.map(item => false)
            // }
        },
        emitChange(filter) {
            this.$emit('filterChange', filter)
        },
        setFilterArray: function() {
            var data = []
            for (var item in this.searchItems) {
                data.push({'anded': this.searchItems[item].value.and_search, 'options': []})
            }
            return data
        },
        resetFilters() {
            this.filter_arrays = this.setFilterArray();
            this.emitChange(this.filter_arrays);
        },
        sOptionId(name, id) {
            if (this.curIndex > -1) {
                return name.toLowerCase().split(' ').join('') + '-' + id + '-' + this.curIndex    
            }
            return name.toLowerCase().split(' ').join('') + '-' + id
        },
        resetChoices(i) {
            let choice = this.openTracker[i]
            if (choice){
                this.openTracker = this.openTracker.map( item => false)
            }else{
                this.openTracker = this.openTracker.map( item => false)
                this.openTracker[i] = true
            }
        },
        splitMenu(menu){
            var full = menu.slice(0)
            var chunk = []
            // console.log('MENU: ', menu)
            // if( menu.length > 12){
            //     console.log('CHUNK')
            while(full.length){
                chunk.push(full.splice(0, 7))
            }
            //  console.log('CHUNK: ', chunk)
            return chunk
            // }else{
            //     return menu
            // }
           
        }
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
    /* .multiselect--active {
        padding-bottom: 400px;
    } */

    input[type='text'].multiselect__input {
        border: none;
        border-radius: 0;
        height: 20px;
        filter: none;
    }

    span.multiselect__option {
        padding-left: 30px;
    }

    span.multiselect__option--group {
        font-weight: bold;
        border-top: solid thin black;
        /* padding-left: 12px; */
        padding: 0;
    }
    div.groupLabel {
        padding: 12px;
    }
</style>
<!--
<style lang="sass">
    button
        transition: background .25s ease-in-out;
    button.selected
        background: $color-pink
        // background: #ef6537
        // background: #efef37
        // color: $color-primary
        // ::hover
        //     background: $color-tertiary
    button.selected:hover
        background: $color-pink
        // background: #ef6537
        // background: #efef37
        
</style>

<style scoped>
    .dropdown-options {
        background-color: #585858;
        color: #ffffff;
        /* overflow: scroll; */
        padding: 2rem;
        transition: all .15s ease-in-out;
        top: -10px;
        left: 9px;
        transform: translateY(-100%);
        z-index: 1;
        position: absolute;
        width: 100%;
        min-width: 30rem;
        text-align: left;
        padding: 2rem 2rem 7rem 2rem !important;
        /* opacity: 0; */
    }

    .search-filter > .full-width > .row{
        max-width: 112rem;
        padding: 0;
        margin: 0 auto;
    }

    .search-filter .done-button{
        position: absolute;
        bottom: 2rem;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: 80%;
    }

    .dropdown-open {
        /* max-height: 500px; */
        /* border: white thin solid; */
        opacity: 1;
        transform: translateY(10px);
    }

    .double-row{
        min-width: 55rem;
    }

    .search-filter{
        /* padding: 1.5rem 0; */
    }

    .search-filter button{
        width: 80%;
        text-align: center;
        background-color: transparent;
        height: 4.5rem;
        padding: 0;
        /* margin: 0; */
        border-radius: 1rem;
        background: #ffffff;
        /* background-color: #e4e4e4; */
        border: 0.25rem solid #333333;
        /* padding: 1rem; */
        color: #333;
    }

    .search-filter .top{
        /* background: #4a4949;
        background-color: #abdf2f;
        background-color: #e4e4e4; */
        /* background: #333; */
        position: relative;
        z-index: 2;
    }

    .search-filter button{
        width: 100%;
    }

    .search-filter .top{
        padding: 2rem 1rem;
    }

    .search-filter button{
        margin: 0;
    }
</style>
-->